import styles from "./dialog.module.scss";
import Icon from "../icons/Icon";
import React, { useEffect, useState } from "react";
import { ButtonBox } from "../button/Button";
import { XWhite } from "../icons/18";

const TooltipA = ({
  isShow = true,
  content,
  direction = "top",
  location = "center",
  pointerLocation = "center",
  textAlign = "center",
  marginForCustom = "",
  zIndex = "",
  close,
}: {
  isShow?: boolean;
  content: string;
  direction?: "top" | "bottom";
  location?: "left" | "center" | "right";
  pointerLocation?: "left" | "center" | "right";
  textAlign?: "left" | "center" | "right";
  marginForCustom?: string; //margin 값으로 위치 조정 필요한 경우 사용
  zIndex?: number | string; // zIndex 조정 없으면 헤더 zIndex - 1
  close?: () => void;
}) => {
  const [toolTipShow, setToolTipShow] = useState(false);
  useEffect(() => {
    if (content && isShow) {
      setToolTipShow(true);
    }
  }, [content, isShow]);

  return isShow && toolTipShow && content ? (
    <div
      className={`${styles["dialog"]} ${styles["dialog--tooltip-a"]} ${styles[`dir-${direction}`]} ${styles[`loc-${location}`]} ${styles[`pointer-${pointerLocation}`]}`}
      style={{
        textAlign: textAlign,
        margin: marginForCustom,
        zIndex: zIndex,
      }}
    >
      <span>{content}</span>
      {close && (
        <ButtonBox
          type={"icon"}
          onClick={() => {
            if (close) {
              close();
              setToolTipShow(false);
            }
          }}
        >
          <Icon IconComponent={<XWhite />} size={18} />
        </ButtonBox>
      )}
    </div>
  ) : null;
};

export default TooltipA;
